// extracted by mini-css-extract-plugin
module.exports = {"workflow-status":"styles_workflow-status__12W7H"};